module.exports = __webpack_public_path__ + "static/media/int_2.d43fb53c.jpg";